import { useState, useEffect } from "react";

// The logged-in employee, so two people sharing a browser keep their own values.
const currentUserId = () => {
  try {
    return JSON.parse(localStorage.getItem("cred"))?.profile?.userId ?? "guest";
  } catch {
    return "guest";
  }
};

const read = (storageKey, initialValue) => {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw === null ? initialValue : JSON.parse(raw);
  } catch {
    return initialValue;
  }
};

/**
 * useState that survives a page refresh: the value is kept in localStorage
 * under `key`, per logged-in user. Use for screen filters, not for data that
 * must be fresh. Storage being blocked only means the value is not kept.
 */
export function usePersistedState(key, initialValue) {
  const storageKey = `${key}:${currentUserId()}`;
  const [value, setValue] = useState(() => read(storageKey, initialValue));

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      // private browsing / storage full — fine, just no persistence
    }
  }, [storageKey, value]);

  return [value, setValue];
}
